export const createCircleGeoJSON = (
  center: [number, number],
  radiusInKm: number,
  points: number = 64
) => {
  const coords = [];
  const [lng, lat] = center;
  const R = 6371;

  for (let i = 0; i <= points; i++) {
    const angle = (i * 360) / points;
    const radians = (angle * Math.PI) / 180;
    const dx = radiusInKm * Math.cos(radians);
    const dy = radiusInKm * Math.sin(radians);

    const newLat = lat + (dy / R) * (180 / Math.PI);
    const newLng = lng + ((dx / R) * (180 / Math.PI)) / Math.cos((lat * Math.PI) / 180);

    coords.push([newLng, newLat]);
  }

  return {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [coords],
    },
  };
};
